(() => {
  const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
  const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
  const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';
  const SCROLL_ANIMATION_DESIGN_MODE_CLASSNAME = 'scroll-trigger--design-mode';
  const revealSelector = [
    `.template-index .${SCROLL_ANIMATION_TRIGGER_CLASSNAME}`,
    `.template-page-collections .${SCROLL_ANIMATION_TRIGGER_CLASSNAME}`,
    `.template-collection .${SCROLL_ANIMATION_TRIGGER_CLASSNAME}`,
    `.template-collection-artist .${SCROLL_ANIMATION_TRIGGER_CLASSNAME}`,
    `.template-product .${SCROLL_ANIMATION_TRIGGER_CLASSNAME}`,
    `.template-metaobject-artist .${SCROLL_ANIMATION_TRIGGER_CLASSNAME}`,
  ].join(', ');
  const isDesignMode = document.documentElement.classList.contains('shopify-design-mode') || window.Shopify?.designMode;

  const onIntersection = (entries, observer) => {
    entries.forEach((entry, index) => {
      const target = entry.target;

      if (entry.isIntersecting) {
        target.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (target.hasAttribute('data-cascade')) {
          target.style.setProperty('--animation-order', index);
        }
        observer.unobserve(target);
      } else {
        target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
      }
    });
  };

  const initializeScrollAnimationTrigger = (root = document, isDesignModeEvent = false) => {
    const items = Array.from(root.querySelectorAll(revealSelector));

    if (!items.length) return;

    if (isDesignMode || isDesignModeEvent || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add(SCROLL_ANIMATION_DESIGN_MODE_CLASSNAME));
      return;
    }

    const observer = new IntersectionObserver(onIntersection, {
      rootMargin: '0px 0px -50px 0px',
    });
    items.forEach((item) => observer.observe(item));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeScrollAnimationTrigger(), { once: true });
  } else {
    initializeScrollAnimationTrigger();
  }

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
    document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
  }
})();
